import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type SchemesSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_SCHEMES_SORT_OPTION: SchemesSortOption = "newest";

const OPTIONS: SortOption<SchemesSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function schemesSortOptionLabel(option: SchemesSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function schemesSortOptionToParams(option: SchemesSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortSchemesPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: SchemesSortOption;
  setSortOption: (option: SchemesSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Schemes"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
